import getEnv from 'utils/getEnv';
import isServer from 'utils/isServer';

const DOMAIN_MAPPING = {
  'en-XX': ['eu', ''],
  'en-CA': ['ca', '/en'],
  'en-GB': ['uk', ''],
  'en-AU': ['au', ''],
  'en-IE': ['ie', ''],
  'en-NZ': ['nz', ''],
  'en-US': ['com', '/en'],
  'cs-CZ': ['cz', ''],
  'no-NO': ['no', ''],
  'sv-SE': ['se', ''],
  'dk-DK': ['dk', ''],
  'fr-CA': ['ca', '/fr'],
  'fr-FR': ['fr', ''],
  'fr-CH': ['ch', '/fr'],
  'fr-BE': ['be', '/fr'],
  'es-ES': ['es', ''],
  'de-DE': ['de', ''],
  'de-AT': ['at', ''],
  'de-CH': ['ch', '/de'],
  'nl-BE': ['be', '/nl'],
  'nl-NL': ['nl', ''],
  'pt-PT': ['pt', ''],
  'pl-PL': ['pl', ''],
  'pt-BR': ['br', ''],
  'it-IT': ['it', ''],
  'en-IN': ['in', ''],
  'es-CL': ['cl', ''],
  'en-SG': ['sg', ''],
};

export type Locale = keyof typeof DOMAIN_MAPPING;

function getClientBaseUrl(locale: Locale, env = getEnv()) {
  const [, suffix] = DOMAIN_MAPPING[locale];
  return env === 'proxy' ? '' : suffix;
}

function getServerBaseUrl(locale: Locale, env = getEnv()) {
  const [prefix, suffix] = DOMAIN_MAPPING[locale];
  switch (env) {
    case 'proxy':
      return `http://localhost:3000`;
    case 'dev':
      return `http://${prefix}-dev.optimalprint.net${suffix}`;
    default:
      return `https://${prefix}.optimalprint.internal.ie.${env}.gelato.tech${suffix}`;
  }
}

export const getBaseUrl = (locale: Locale, env = getEnv()) => {
  return (isServer() ? getServerBaseUrl : getClientBaseUrl)(locale, env);
};
